import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_ORIGIN = 'https://harvesthelp.app'

function canonicalUrlFor(pathname: string): string {
  const clean = pathname.replace(/\/+$/, '') || '/'
  return clean === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${clean}`
}

const CanonicalTag = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const href = canonicalUrlFor(pathname)

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = href

    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]')
    if (ogUrl) ogUrl.setAttribute('content', href)
  }, [pathname])

  return null
}

export default CanonicalTag
